import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MemreFlexBox from './MemreFlexBox';
import MemreIcon from './MemreIcon';
import MemreText from './MemreText';

export default function MemreToggleButtonGroup({ options, value, onChange }) {
  return (
    <ToggleButtonGroup
      exclusive={true}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      aria-label="text alignment"
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value} sx={{ px: 2, py: 1 }}>
          <MemreFlexBox gap={1.15} direction="row" align="center" justify="center">
            {option.iconName && <MemreIcon fontSize="1.15em" iconName={option.iconName} />}
            <MemreText variant="caption">{option.label}</MemreText>
          </MemreFlexBox>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
